export const ME_BOOT_REQUEST_PATH = '/user/v2/me?expand=worksAt';
export function discardMeBootPrefetch() {
    delete window.__meBootPrefetch;
}
export function takeMeBootPrefetch(bootContext) {
    const prefetch = window.__meBootPrefetch;
    delete window.__meBootPrefetch;
    if (prefetch == null) return null;
    const matchesBootContext = prefetch.token === bootContext.authToken && prefetch.url === bootContext.apiGatewayHost + ME_BOOT_REQUEST_PATH;
    if (!matchesBootContext) return null;
    return prefetch.response.then((response)=>response.status === 200 ? response.json() : null).catch(()=>null);
}
